"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _StoreTileList = require("@ccw-pwa-ui/StoreTileList");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
require("../styles/HomeDashboardStore.css");
var _helper = require("../common_features/utility/helper");
const HomeDashboardStoreComponent = _ref => {
  let {
    stores,
    handleClick,
    loginType,
    successLabel,
    handleCreateStore,
    userType,
    isDisableIcon,
    isDisableText,
    onScrollHandler,
    everythingOkIcon,
    listInnerRef,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    onScroll: onScrollHandler,
    ref: listInnerRef
  }, !userType ? /*#__PURE__*/_react.default.createElement("div", {
    className: "ownerMobileIcon-iconWrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ownerMobileIcon-left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "handleCreateStorediv-class",
    onClick: handleCreateStore,
    "data-testid": "handleCreateStorediv"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.plusStoreIcon.default,
    alt: "+"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "ownerMobileIcon-storeContent"
  }, "Store")))) : null, /*#__PURE__*/_react.default.createElement(_StoreTileList.StoreTileList, (0, _extends2.default)({
    stores: stores,
    handleClick: handleClick,
    successLabel: successLabel,
    loginType: loginType,
    isDisableIcon: isDisableIcon,
    isDisableText: isDisableText,
    onScrollHandler: onScrollHandler,
    errorIcon: _index.default.High.default,
    arrowIcon: _index.default.ArrowRight.default,
    everythingOkIcon: everythingOkIcon,
    infoIcon: _index.default.infoIcon.default,
    optmizeIcon: _index.default.lowIcon.default
  }, rest)));
};
var _default = exports.default = HomeDashboardStoreComponent;